import React from 'react';

function Footer() {   
    return (
    <footer className="footer bg-dark fixed-bottom">
        <a href="https://github.com/JJackson510"><img src="https://img.icons8.com/color/48/000000/github--v1.png" alt="Github" className="icon"/></a>
        <a href="https://www.linkedin.com/in/jamie-jackson510/"><img src="https://img.icons8.com/fluent/48/000000/linkedin.png" alt="LinkedIn" className="icon"/></a>
        
    </footer>
    )
}

export default Footer;